module.exports = [
  require('./parser_array.js'),
  require('./parser_json.js'),
  require('./parser_omit.js'),
  require('./parser_jsonarray.js'),
  require("./parser_flat.js")
];
